module.exports = __webpack_public_path__ + "img/settings.7eb24b64.svg";